import { AxiosResponse } from 'axios'
import apiClient from 'api/common/common'
import { ConnectorChangePasswordRequest, PasswordRegistrationRequest, PasswordResetRequest } from 'api/common/requests'
import { Status } from 'api/common/statuses'
import { PasswordResetResponse } from 'api/common/responses'

/**
 * パスワード変更API
 * @param request
 * @param callback
 */
export const passwordEditAPI = async (request: ConnectorChangePasswordRequest, callback: (result: boolean) => void) => {
  await apiClient
    .post('/connector/changePassword', request)
    .then((response: AxiosResponse) => {
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      if (status === Status.Success) {
        callback(true)
      } else {
        callback(false)
      }
    })
    .catch((error) => {
      console.error(error)
    })
}

/**
 * パスワード再設定API
 * @param request
 * @param callback
 */
export const passwordResetAPI = async (request: PasswordResetRequest, callback: (status: Status, result: boolean) => void) => {
  await apiClient
    .post('/passwordReset', request)
    .then((response: AxiosResponse<PasswordResetResponse>) => {
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      const apiResult = response?.data?.result ?? false
      callback(status, apiResult)
    })
    .catch((error) => {
      console.error(error)
    })
}

/**
 * パスワード登録API
 * @param request
 * @param callback
 */
export const passwordRegistrationAPI = async (request: PasswordRegistrationRequest, callback: (result: boolean) => void) => {
  await apiClient
    .post('/passwordRegistration', request)
    .then((response: AxiosResponse) => {
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      if (status === Status.Success) {
        callback(true)
      } else {
        callback(false)
      }
    })
    .catch((error) => {
      console.error(error)
    })
}
